import Styles from './appPreview.module.css';
import React, { useEffect, useState } from 'react';
import PhotoPreview from './../../../../image/auth/preview/photo.png';
import StorePreview from './../../../../image/auth/preview/store.png';
import TopPagePreview from './../../../../image/auth/preview/top-page.png';

const PREVIEWS = [
  { src: TopPagePreview, alt: 'memorii worksのトップページ画面' },
  { src: PhotoPreview, alt: '写真で見る画面' },
  { src: StorePreview, alt: '店舗紹介画面' },
];

const AppPreview = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((current) => (current + 1) % PREVIEWS.length);
    }, 3000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className={Styles.phone}>
      <div className={Styles.notch} />
      <div className={Styles.screen}>
        {PREVIEWS.map((preview, index) => (
          <img
            key={preview.src}
            src={preview.src}
            alt={preview.alt}
            className={`${Styles.shot} ${active === index ? Styles.shotActive : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AppPreview;
